import { render, staticRenderFns } from "./AllFleetData.vue?vue&type=template&id=fc84ae92&scoped=true"
import script from "./AllFleetData.vue?vue&type=script&lang=js"
export * from "./AllFleetData.vue?vue&type=script&lang=js"
import style0 from "./AllFleetData.vue?vue&type=style&index=0&id=fc84ae92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc84ae92",
  null
  
)

export default component.exports